/**
 * Edition configuration — Community edition only.
 *
 * This is the community (self-hosted) build. There is no cloud edition
 * in this repository.
 */

export const EDITION = 'community' as const

export const isCommunity = true
export const isCloud = false
